import Button from 'components/Forms/Button/Button';
import { FooterContent } from 'components/Layout/Footer/FooterContent/FooterContent';
import FooterCopyright from 'components/Layout/Footer/FooterCopyright/FooterCopyright';
import { useEffectOnce } from 'hooks/ui/useEffectOnce';
import useTranslation from 'next-translate/useTranslation';
import { ChevronIcon } from 'public/svg/IconsSvg';
import { memo } from 'react';
import * as smoothscroll from 'smoothscroll-polyfill';

function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    });
}

type Props = {
    simple?: boolean;
    withoutMoveUpActionButton?: boolean;
};

const FOOTER_TEST_IDENTIFIER = 'layout-footer';

const Footer = memo<Props>(({ simple, withoutMoveUpActionButton }) => {
    const { t } = useTranslation();

    useEffectOnce(() => smoothscroll.polyfill());

    return (
        <div className="relative flex flex-col pb-40 pt-14 vl:pb-20 vl:pt-12" data-testid={FOOTER_TEST_IDENTIFIER}>
            {!withoutMoveUpActionButton && (
                <Button
                    className="absolute -top-5 left-1/2 -translate-x-1/2 self-center whitespace-nowrap px-7 vl:hidden [&>svg:first-child]:mr-2.5"
                    size="small"
                    type="button"
                    onClick={scrollToTop}
                >
                    <ChevronIcon className="h-2.5 w-2.5 first:mr-2" />
                    <span>{t('Move up')}</span>
                </Button>
            )}
            {!simple && <FooterContent />}
            <FooterCopyright />
        </div>
    );
});

Footer.displayName = 'Footer';

export default Footer;
